import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'


export const currencyTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS', 'ADD_EMPTY'], 'CURRENCY');


export const requestCurrency = () => {
    return {
        type: currencyTypes.REQUEST,
    };
};

export const receiveCurrency = (response) => {
    return {
        type: currencyTypes.RECEIVE,
        data: response,
    };
};

export const receiveCurrencyError = (response) => {
    return {
        type: currencyTypes.ERROR,
        error: response,
    };
};

export const fetchCurrency = (code) => {
    return dispatch => {

        let success = true

        const apiUrl = `/api/v1/currency/${code}/`

        dispatch(requestCurrency());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveCurrency(response));
            } else {
                dispatch(receiveCurrencyError(response))
            }
        })
        .catch(handleNetworkError);
    };
};